import React, { useState, useEffect } from 'react';
import appState, { AppState } from '../../model/state';

export type ComponentConstructor<T> = (props: Readonly<T>) => JSX.Element;

export type StatePicker<V> = (s: AppState) => V;

type NotIn<T, U> = Pick<T, Exclude<keyof T, keyof U>>

export const useAppState = <T,>(picker: StatePicker<T>): T => {
    const [_state, _setState] = useState(picker(appState.get()));
    useEffect(() => {
        const observer = (s: Readonly<AppState>) => _setState(picker(s));
        appState.subscribe(observer);
        return () => appState.unsubscribe(observer);
    }, []);

    return _state;
}

export const stateConnect = <S, TProps>(WrappedComponent: ComponentConstructor<TProps>, picker: StatePicker<S>) =>
    (props: Readonly<NotIn<TProps, S>>) => {
        const _state = useAppState(picker);

        const _props = { ..._state, ...props } as unknown as Readonly<TProps>;
        return <WrappedComponent {..._props} />;
    }